/* eslint-disable consistent-return */
import { CohesionFn } from './types/cohesion-types';

export const cohesion: CohesionFn = (eventName, ...args) => {
    if (typeof window !== 'undefined' && typeof window.cohesion === 'function') {
        return window.cohesion(eventName, ...args);
    }
    console.error('[cohesion-utils] window.cohesion is not defined');
};
